import { useTranslation } from 'react-i18next';
import { Select } from '@/components/form/Select';
import { LoaderWrapper } from '@/components/profile/LoaderWrapper';
import type { ThemeMode } from '@/helpers/enums';
import { required } from '@/helpers/validators';
import { useCountryState } from '@/hooks';
import { useStateOptions } from '@/modules/profile/hooks/useStateOptions';
import { useGetCommonStore } from '@/store';

export const ProfileInfoStatesField = ({ mode }: { mode?: ThemeMode }) => {
  const useCommonStore = useGetCommonStore();

  const user = useCommonStore.use.user();
  const countryCode = useCommonStore.use.countryCode();
  const { t } = useTranslation(['common', 'validation']);

  const { states, statesPending, defaultState } = useCountryState(
    user?.country || countryCode
  );

  const { statesOptions } = useStateOptions(states);

  return (
    <LoaderWrapper loading={statesPending}>
      {statesOptions?.length ? (
        <Select
          initialValue={user?.state || defaultState || undefined}
          mode={mode}
          name="state"
          options={statesOptions}
          placeholder={t('auth.registration.form.state')}
          validate={required}
        />
      ) : null}
    </LoaderWrapper>
  );
};
